import { createAxiosInstance } from './createAxiosInstance'

export const externalExchangeClient = createAxiosInstance({
  apiType: 'regular',
  requestConfig: {
    baseURL: 'https://converter.pointsone.com/api/',
  },
})
